/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { eventsList } from "../../funcs/eventsList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEventsRequest$inboundSchema,
};

export const tool$eventsList: ToolDefinition<typeof args> = {
  name: "events-list",
  description: `List Events

Retrieves a list of events.

When authenticated with a Tenant JWT, returns only events belonging to that tenant.
When authenticated with Admin API Key, returns events across all tenants. Use \`tenant_id\` query parameter to filter by tenant.
`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await eventsList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
